import RootAuthenticated from '@/pages/_authenticated';
import Auth from '@/pages/_auth';
// import Dashboard from '@/pages/_authenticated/dashboard';
import User from '@/pages/_authenticated/user';
import Project from '@/pages/_authenticated/project';
import UpdateProject from '@/pages/_authenticated/project/update';
// import ProtectedPage from '@/pages/_authenticated/protective';
import CreateProject from '@/pages/_authenticated/project/create';
// import CreateProtectiveItem from '@/pages/_authenticated/protective/create-item/createItem.protective';
// import UpdateProtective from '@/pages/_authenticated/protective/update/update.protective';
// import AssignToEmployee from '@/pages/_authenticated/protective/assignToEmployee/assignToEmployee';
import DayOff from '@/pages/_authenticated/dayOff';
import Attendance from '@/pages/_authenticated/attendance';
import Task from '@/pages/_authenticated/task';
import TaskList from '@/pages/_authenticated/task/components/task-list';
import CreateTask from '@/pages/_authenticated/task/components/create-task';
import UpdateTask from '@/pages/_authenticated/task/components/update-task';
import ListReport from '@/pages/_authenticated/report/components/list-report';
import DetailReport from '@/pages/_authenticated/report/components/detail-report';
import Report from '@/pages/_authenticated/report';
import ProjectMembers from '@/pages/_authenticated/project/add-members';
import TrackingTime from '@/pages/_authenticated/trackingTime';
import ListTracking from '@/pages/_authenticated/trackingTime/components/list-tracking';
import DetailTracking from '@/pages/_authenticated/trackingTime/components/detail-tracking';
import ActivityStatistics from '@/pages/_authenticated/user/components/activityStatistics';
import Wfh from '@/pages/_authenticated/wfh';
import S3File from '@/pages/_authenticated/s3File';
import ManualLog from '@/pages/_authenticated/manualLog';
import StatisticsTracking from '@/pages/_authenticated/trackingTime/components/statistics-tracking';
import Setting from '@/pages/_authenticated/setting';
import CreateSetting from '@/pages/_authenticated/setting/components/create-setting';
import ListSetting from '@/pages/_authenticated/setting/components/list-setting';
import UpdateSetting from '@/pages/_authenticated/setting/components/update-setting';
import TestPrompt from '@/pages/_authenticated/testPromt';
import CheckSocialMedia from '@/pages/_authenticated/testPromt/components/CheckSocialMedia';
import { ReactNode } from 'react';
import LeavePage from '@/pages/_authenticated/leave';
import Leaves from '@/pages/_authenticated/leave/components/leaves';
import PayrollPage from '@/pages/_authenticated/payroll';

export const PUBLIC_ROUTES = [
    {
        path: '/login',
        component: Auth,
        layout: null,
    },
];

type LayoutType = {
    children: ReactNode;
};

type RouterType = {
    path: string;
    component: React.FC;
    layout?: React.FC<LayoutType>;
    children?: RouterType[];
    isPrivate?: boolean;
    isAuth?: boolean;
    title?: string;
    icon?: React.FC;
    allowedRoles?: string[];
};

type RouterConfigType = RouterType[];

export type { RouterType, RouterConfigType, LayoutType };

export const PRIVATE_ROUTES = [
    {
        path: '/',
        component: RootAuthenticated,
        layout: null,
        index: true,
        children: [
            // {
            //     path: '/',
            //     component: Dashboard,
            //     layout: null,
            //     index: true,
            // },
            {
                path: '/',
                component: User,
                layout: null,
                allowedRoles: ['admin'],
                children: [
                    {
                        path: '/activity-statistics/:id',
                        component: ActivityStatistics,
                        layout: null,
                        allowedRoles: ['admin'],
                    },
                ],
            },
            {
                path: '/projects',
                component: Project,
                layout: null,
                allowedRoles: ['admin'],
                children: [
                    {
                        path: 'update-project',
                        component: UpdateProject,
                        layout: null,
                        allowedRoles: ['admin'],
                    },
                    {
                        path: 'create-project',
                        component: CreateProject,
                        layout: null,
                        allowedRoles: ['admin'],
                    },
                    {
                        path: 'add-members',
                        component: ProjectMembers,
                        layout: null,
                        allowedRoles: ['admin'],
                    },
                ],
            },
            // {
            //     path: '/protective',
            //     component: ProtectedPage,
            //     layout: null,
            //     children: [
            //         {
            //             path: 'update',
            //             component: UpdateProtective,
            //             layout: null,
            //         },
            //         {
            //             path: 'create-protective-item',
            //             component: CreateProtectiveItem,
            //             layout: null,
            //         },
            //         {
            //             path: 'assign-to-employee',
            //             component: AssignToEmployee,
            //             layout: null,
            //         },
            //     ],
            // },
            {
                path: '/day-off',
                component: DayOff,
                layout: null,
                allowedRoles: ['admin'],
            },
            {
                path: '/attendance',
                component: Attendance,
                layout: null,
                allowedRoles: ['admin'],
            },
            {
                path: '/tasks',
                component: Task,
                layout: null,
                allowedRoles: ['admin'],
                children: [
                    {
                        path: '',
                        component: TaskList,
                        layout: null,
                        allowedRoles: ['admin'],
                    },
                    {
                        path: 'create-task',
                        component: CreateTask,
                        layout: null,
                        allowedRoles: ['admin'],
                    },
                    {
                        path: 'update-task',
                        component: UpdateTask,
                        layout: null,
                        allowedRoles: ['admin'],
                    },
                ],
            },
            {
                path: '/report',
                component: Report,
                layout: null,
                allowedRoles: ['admin'],
                children: [
                    {
                        path: '',
                        component: ListReport,
                        layout: null,
                        allowedRoles: ['admin'],
                    },
                    {
                        path: 'detail-report',
                        component: DetailReport,
                        layout: null,
                        allowedRoles: ['admin'],
                    },
                ],
            },
            {
                path: '/tracking-time',
                component: TrackingTime,
                layout: null,
                allowedRoles: ['admin', 'manager'],
                children: [
                    {
                        path: '',
                        component: ListTracking,
                        layout: null,
                        allowedRoles: ['admin', 'manager'],
                    },
                    {
                        path: ':id',
                        component: DetailTracking,
                        layout: null,
                        allowedRoles: ['admin', 'manager'],
                    },
                    {
                        path: 'statistics',
                        component: StatisticsTracking,
                        layout: null,
                        allowedRoles: ['admin', 'manager'],
                    },
                ],
            },
            {
                path: '/payroll',
                component: PayrollPage,
                layout: null,
                allowedRoles: ['admin'],
            },
            {
                path: '/wfh',
                component: Wfh,
                layout: null,
                allowedRoles: ['admin'],
            },
            {
                path: '/s3-file',
                component: S3File,
                layout: null,
                allowedRoles: ['manager', 'admin'],
            },
            {
                path: '/manual-log',
                component: ManualLog,
                layout: null,
                allowedRoles: ['admin'],
            },
            {
                path: '/setting',
                component: Setting,
                layout: null,
                allowedRoles: ['admin', 'manager'],
                children: [
                    {
                        path: 'create-setting',
                        component: CreateSetting,
                        layout: null,
                        allowedRoles: ['admin'],
                    },
                    {
                        path: 'list-setting',
                        component: ListSetting,
                        layout: null,
                        allowedRoles: ['admin', 'manager'],
                    },
                    {
                        path: 'update-setting/:key',
                        component: UpdateSetting,
                        layout: null,
                        allowedRoles: ['admin', 'manager'],
                    },
                ],
            },
            {
                path: '/test-promt',
                component: TestPrompt,
                layout: null,
                allowedRoles: ['admin'],
                children: [
                    {
                        path: 'check-user-using-social-media',
                        component: CheckSocialMedia,
                        layout: null,
                        allowedRoles: ['admin'],
                    },
                ],
            },
            {
                path: '/leave',
                component: LeavePage,
                layout: null,
                allowedRoles: ['admin'],
                children: [
                    {
                        path: '',
                        component: Leaves,
                        layout: null,
                        allowedRoles: ['admin'],
                    },
                ],
            },
        ],
    },
];
